import React, { useState, useEffect } from "react";
import ConfiguracoesIA from "./ConfiguracoesIA";
import Biblioteca from "./Biblioteca";
import LogsIA from "./LogsIA";
import PendenciasIA from "./PendenciasIA";
import BloqueadosIA from "./BloqueadosIA";
import ArquivosDisparos from "./ArquivosDisparos";
import axios from "axios";
import "./PainelIA.css"; 

const PainelIA = () => {
  const [aba, setAba] = useState("configuracoes");
  const [qtdPendencias, setQtdPendencias] = useState(0);

  const carregarPendencias = () => {
  const usuario_id = localStorage.getItem('usuario_id');
  axios
    .get("https://welaunchyou.com.br/crm-wly/api/openai/pendencias_ia.php", {
      withCredentials: true,
      params: { usuario_id }
    })
    .then(res => {
      if (res.data.success && Array.isArray(res.data.pendencias)) {
        setQtdPendencias(res.data.pendencias.length);
      } else {
        setQtdPendencias(0);
      }
    })
    .catch(() => setQtdPendencias(0));
};


  useEffect(() => {
    carregarPendencias();
  }, []);

  useEffect(() => {
    if (aba === "pendencias") {
      carregarPendencias();
    }
  }, [aba]);

  return (
          <div className="texto-titulo">
          <h1 className="painel-ia-titulo">Painel de Inteligência Artificial</h1>

    <div className="painel-ia-wrapper">

      <div className="painel-ia-abas">
        <div className={`painel-ia-aba ${aba === "configuracoes" ? "ativa" : ""}`} onClick={() => setAba("configuracoes")}>
          Configurações
        </div>
        <div className={`painel-ia-aba ${aba === "biblioteca" ? "ativa" : ""}`} onClick={() => setAba("biblioteca")}>
          Biblioteca
        </div>
        <div className={`painel-ia-aba ${aba === "material-envio" ? "ativa" : ""}`} onClick={() => setAba("material-envio")}>
          Material de envio
        </div>

        <div className={`painel-ia-aba ${aba === "logs" ? "ativa" : ""}`} onClick={() => setAba("logs")}>
          Respostas
        </div>
        <div className={`painel-ia-aba ${aba === "pendencias" ? "ativa" : ""}`} onClick={() => setAba("pendencias")}>
          Pendências{" "}
          {qtdPendencias > 0 && (
            <span style={{
              background: 'red',
              color: 'white',
              borderRadius: '9999px',
              padding: '2px 8px',
              fontSize: '12px',
              marginLeft: '6px'
            }}>
              {qtdPendencias}
            </span>
          )}
        </div>
        <div className={`painel-ia-aba ${aba === "bloqueados" ? "ativa" : ""}`} onClick={() => setAba("bloqueados")}>
          Bloqueios
        </div>
      </div>

      <div className="painel-ia-conteudo">
        {aba === "configuracoes" && <ConfiguracoesIA />}
        {aba === "biblioteca" && <Biblioteca />}
        {aba === "material-envio" && <ArquivosDisparos />}
        {aba === "logs" && <LogsIA />}
        {aba === "pendencias" && <PendenciasIA atualizarContador={carregarPendencias} />}
        {aba === "bloqueados" && <BloqueadosIA />}
      </div>
    </div></div>
  );
};

export default PainelIA;
